<template>
	<div>
		<span>{{tel}}</span>
		<v-icon v-if="tel" color="blue" small @click="call">call</v-icon>
		<v-icon small v-if="tel" color="green" @click="whatsapp">mdi-whatsapp</v-icon>
	</div>
</template>

<script>
	export default {
		name: "whatsapp-link",
		props: ["tel"],
		computed: {
			cleanTel() {
				let numb = this.tel.match(/\d/g);
				return numb.join("");
			},
			whatsappherf() {
				return ("https://wa.me/" + "972" + this.cleanTel.slice(1, this.tel.length));
			},
		},
		methods: {
			whatsapp() {
				window.open(this.whatsappherf, "_blank");
			},

			call() {
				window.location = "tel:" + this.cleanTel;
			}

		}
	};
</script>

<style scoped>

</style>